import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Componentes
import MainCard from '../../../components/MainCard';
import TextField from '../../../components/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//API
import usuario_api from '../../../api/usuario_api';

//Context
import { useAuth } from '../../../context/auth';
import { getSessionCookie } from '../../../helpers/cookies';


function initialStateTrocaSenha(usuario_id) {
    return {
        senhaAntiga: "",
        novaSenha: "",
        confirmarNovaSenha: "",
        id: usuario_id
    }
}

export default function TrocaSenha() {
    //Objeto com dado de autenticação
    const session = getSessionCookie();

    //State para Troca senha
    const [trocaSenha, setTrocaSenha] = useState(initialStateTrocaSenha(session.id));

    //State para pegar erros
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "senhaAntiga", required: true }),
        objCampo({ name: "novaSenha", required: true }),
        objCampo({ name: "confirmarNovaSenha", required: true })
    ])

    const onChange = (e) => {
        const { name, value } = e.target;
        const _trocaSenha = {
            ...trocaSenha,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_trocaSenha, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setTrocaSenha(_trocaSenha);
    }

    const handleTrocaSenha = () => {
        const _errors = validarCampos(trocaSenha, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        if (trocaSenha.novaSenha !== trocaSenha.confirmarNovaSenha) {
            showMessage("Aviso", "A confirmação de senha não confere com a nova senha informada", "error", null);
            return;
        }

        setLoading(true);
        usuario_api.trocaSenha(trocaSenha).then(response => {
            showMessage("Aviso", "Operação realizada com sucesso", "success", null);
            setTrocaSenha(initialStateTrocaSenha());
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    return <>
        <MainCard>
            <h4 className='text-secondary m-0'>Trocar Senha</h4>
            <Row className='mt-2'>
                <Col md={12} lg={4}>
                    <TextField
                        label={"* Senha Antiga"}
                        name={"senhaAntiga"}
                        onChange={onChange}
                        value={trocaSenha.senhaAntiga}
                        invalid={errors.senhaAntiga}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        label={"* Nova Senha"}
                        name={"novaSenha"}
                        onChange={onChange}
                        value={trocaSenha.novaSenha}
                        invalid={errors.novaSenha}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        label={"* Confirmar Senha"}
                        name={"confirmarNovaSenha"}
                        onChange={onChange}
                        value={trocaSenha.confirmarNovaSenha}
                        invalid={errors.confirmarNovaSenha}
                    />
                </Col>
            </Row>
            <Row className='d-flex justify-content-center align-items-center mt-2'>
                <Col md={12} lg={4} className='text-center'>
                    <Button
                        color='primary'
                        onClick={handleTrocaSenha}
                    >
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}